import { render } from "./stratlist.vue?vue&type=template&id=71890b8e&ts=true"
import script from "./stratlist.vue?vue&type=script&lang=ts"
export * from "./stratlist.vue?vue&type=script&lang=ts"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__